import {createSelector} from 'reselect';

import {getUIState} from '../../../../ui-selectors';

const getInstagramState = createSelector([getUIState], (uiState) => uiState.instagram);

const getInstagramChartState = createSelector(
    [getInstagramState],
    (instagram) => instagram.timeseriesChart
);

export const getCurrentReportChartIsLoading = createSelector(
    [getInstagramChartState],
    (timeseriesChartState) => timeseriesChartState.isLoading
);

export const isChartTimedOut = createSelector(
    [getInstagramChartState],
    (timeseriesChartState) => timeseriesChartState.isTimedOut
);

export const isChartErrored = createSelector(
    [getInstagramChartState],
    (timeseriesChartState) => timeseriesChartState.isErrored
);

export const getCurrentReportChartData = createSelector(
    [getInstagramChartState],
    (timeseriesChartState) => timeseriesChartState.chartData
);
